import {html} from 'lit';

export const facet2Template = () => html`
    <div class="image-facet-2-md">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Ebene_1" x="0px" y="0px" viewBox="0 0 360 270" xml:space="preserve">
            <g>
                <path class="fill-yellow400" d="M360,112.3l-139.5,80.5c22.6,39,72.5,52.5,111.6,29.9c11.7-6.8,21.1-16,27.9-26.6V112.3z"/>
            </g>
        </svg>
    </div>

    <div class="image-facet-2-lg">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Ebene_1" x="0px" y="0px" viewBox="0 0 678.5 609" style="enable-background:new 0 0 678.5 609;" xml:space="preserve">
            <g>
                <path class="fill-yellow400" d="M584.4,215.9c-48.4,0-87.8-39.4-87.8-87.8s39.4-87.8,87.8-87.8s87.8,39.4,87.8,87.8S632.9,215.9,584.4,215.9z"/>
                <path class="fill-violet2" d="M6.4,309.5l107.2,61.7V247.5L6.4,309.5z"/>
                <path class="fill-blue" d="M113.6,123.5l-80.4,46.6c-16.6,9.6-26.8,27.3-26.8,46.5v93.1l107.2-62.1V123.5z"/>
                <path class="fill-lightblue400" d="M400.6,510.6c30.7,52.8,98.3,70.8,151.1,40.1c52.8-30.7,70.8-98.3,40.1-151.1L400.6,510.6z"/>
            </g>
        </svg>
    </div>

    <div class="image-facet-2__onDark">
            <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 471 387" style="enable-background:new 0 0 471 387;" xml:space="preserve">
                <path class="fill-lightblue400-opacity-75" d="M40.2,117.8c21.8,0,39.5-17.7,39.5-39.5c0-21.8-17.7-39.5-39.5-39.5c-21.8,0-39.5,17.7-39.5,39.5
                C0.7,100.1,18.4,117.8,40.2,117.8z"/>
                    <path class="fill-violet500" d="M344.3,254v84.9l-47.8,27.6c-15.9,9.2-35.5,9.2-51.5,0l-47.8-27.6L344.3,254z"/>
                    <path class="fill-yellow600" d="M450.3,158.2c0,21.4-11.4,41.1-29.9,51.8L344.3,254V131.6l29.9-17.3C408,94.8,450.3,119.2,450.3,158.2z"/>
            </svg>
    </div>
`;